import { FeatureCard } from './featureCard/featureCard.component';

export { FeatureCard };
